import React from 'react';

import { SVGComponentProps } from './svg.types';

const ManageMembersSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M16.2581 4.87484L11.3081 2.0165C10.4998 1.54984 9.49977 1.54984 8.68311 2.0165L3.74144 4.87484C2.93311 5.3415 2.43311 6.20817 2.43311 7.14984V12.8498C2.43311 13.7832 2.93311 14.6498 3.74144 15.1248L8.69144 17.9832C9.49977 18.4498 10.4998 18.4498 11.3164 17.9832L16.2664 15.1248C17.0748 14.6582 17.5748 13.7915 17.5748 12.8498V7.14984C17.5664 6.20817 17.0664 5.34984 16.2581 4.87484ZM9.99977 6.1165C11.0748 6.1165 11.9414 6.98317 11.9414 8.05817C11.9414 9.13317 11.0748 9.99984 9.99977 9.99984C8.92477 9.99984 8.05811 9.13317 8.05811 8.05817C8.05811 6.9915 8.92477 6.1165 9.99977 6.1165ZM12.2331 13.8832H7.76644C7.09144 13.8832 6.69977 13.1332 7.07477 12.5748C7.64144 11.7332 8.74144 11.1665 9.99977 11.1665C11.2581 11.1665 12.3581 11.7332 12.9248 12.5748C13.2998 13.1248 12.8998 13.8832 12.2331 13.8832Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ManageMembersSVG;
